import { DEFAULTS } from '../video-component';
import { canPlay } from '../video-viewer';
function getUrl(store) {
    var componentData = store.get('componentData');
    return componentData ? componentData.src : '';
}
function updateUrl(src, store) {
    store.update('componentData', { src: src });
}
export default {
    config: DEFAULTS.config,
    title: 'Set Link for Video',
    description: 'Add a link to your video',
    placeholder: 'https://www.youtube.com/watch?v=gi7dTKse9Tg',
    errorMessage: 'Please enter a correct address',
    validateUrl: canPlay,
    getUrl: getUrl,
    updateUrl: updateUrl,
    inputAlwaysEmpty: true,
};
//# sourceMappingURL=link-modal.config.js.map